import Vue from "vue";
import Vuex from "vuex";
import api from "../assets/js/request/api/index";
import Cookies from "js-cookie";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    isLogin: false,
    redirect: '',
    cityId: '',
    applyFormData: {},
  },
  mutations: {
    setUser(state, obj) {
      state.isLogin = true
      var user = {
        uid: obj.uid,
        user_key: obj.user_key,
      };
      //user_username
      Cookies.set("user_username", obj.username, {
        expires: 365,
      });
      Cookies.set("user", user, {
        expires: 365,
      });
      state.user = obj;
    },

    loginOut(state) {
      state.isLogin = false
      state.user = {};
      state.imreward = "";
      Cookies.remove("user");
      Cookies.remove("user_username");
      if (Cookies.get("appletUser")) {
        //如果存在applerUser cookie 也去除
        Cookies.remove("appletUser");
      }
    },
    setRedirect(state, url) {
      state.redirect = url
    },
    setCityId(state, url) {
      state.cityId = url
    },
    setApplyFormData(state, item) {
      state.applyFormData = item
    }
  },
  actions: {

    getUser(context) {
      var user = Cookies.get("user") ? true : false;
      if (user) {
        api.getUser.getUserInfo({}).then((res) => {
          if (res.code == 200) {
            context.commit("setUser", res.result);
          }
        });
      }
    },

  },

});
